<template>
  <div>
    <div>
      <el-radio-group style="margin:0 10px 0 0" size="medium" v-model="typeValue">
        <el-radio v-for="(elem,i) of typeList" :key="i" :label="elem.id">{{elem.name}}</el-radio>
      </el-radio-group>
      <el-date-picker
        v-show="typeValue == 5"
        size="medium"
        value-format="yyyy-MM-dd"
        v-model="startDate"
        type="date"
        placeholder="选择开始日期"
      >
      </el-date-picker>
      <el-date-picker
        v-show="typeValue == 5"
        size="medium"
        value-format="yyyy-MM-dd"
        v-model="endDate"
        type="date"
        placeholder="选择结束日期"
      >
      </el-date-picker>
      <el-input v-model="orgName" style="width:200px" size="medium"  placeholder="请输入医院名称"></el-input>
      <!-- <tree-select
        v-if="orgBack && orgId == 1"
        @treeAll="getOrgValue"
        @reset="orgName = ''"
        :disabled="false"
        style="
          width: 200px;
          display: inline-block;
          vertical-align: bottom;
          font-size: 14px;
        "
        placeholder="请输入医院名称"
        :option="orgOption"
      ></tree-select>
      <tree-select-sec
        v-if="orgBack && orgId != 1"
        @reset="orgName = ''"
        @treeAll="getOrgValue"
        :disabled="false"
        style="
          width: 200px;
          display: inline-block;
          vertical-align: bottom;
          font-size: 14px;
        "
        placeholder="请输入医院名称"
        :option="orgOption"
      ></tree-select-sec> -->
      <el-button size="medium" @click="getpage(1)">筛选</el-button>
    </div>
    <el-divider></el-divider>
    <div>
      <el-table :data="list" border>
        <el-table-column align="center" type="index" width="50">
        </el-table-column>
        <el-table-column align="center" label="机构名称">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>机构名称: {{ scope.row.orgName }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.orgName }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" label="登入次数">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.loginNum }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page
      @givePageIndex="getpage"
      :index="page"
      :pageSize="pageSize"
      :total="total"
    ></page>
  </div>
</template>

<script>
import treeSelect from "../../components/treeSelect";
import treeSelectSec from "./treeSelect1";
import page from "../../components/pages";
export default {
  components: {
    treeSelect,
    page,
    treeSelectSec,
  },
  created() {
    this.orgId = sessionStorage.getItem("orgId");
  },
  mounted() {
    this.load();
    // this.getOrgList();
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      orgId: "",
      orgBack: false,
      orgOption: [],
      orgName: "",
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      typeList: [
        { name: "当日", id: 1 },
        { name: "本周", id: 2 },
        { name: "本月", id: 3 },
        { name: "本年", id: 4 },
        { name: "日期范围", id: 5 },
      ],
      typeValue: 4,
    };
  },
  methods: {
    // getOrgValue(x) {
    //   this.orgName = x.id;
    // },
    // getOrgList() {
    //   this.orgBack = false;
    //   this.$api.structureChildrenList().then((res) => {
    //     // console.log(res);
    //     if (res.data.code == 200) {
    //       this.orgBack = true;

    //       this.orgOption = res.data.data;
    //     }
    //   });
    // },
    load() {
      let obj = {
        pageNo: this.page,
        pageSize: this.pageSize,
        orgName: this.orgName,
        type: this.typeValue,
        startTime: this.startDate,
        endTime: this.endDate,
        // search: this.search,
      };
      console.log(obj);
      this.$api.hospitalSumMore(obj).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.list = res.data.data.records;
          this.page = res.data.data.current;
          this.pageSize = res.data.data.size;
          this.total = res.data.data.total;
        }
      });
    },
    getpage(x) {
      //分页
      console.log(x);
      this.page = x;
      this.load();
    },
  },
};
</script>

<style scoped>
</style>